<template>
    <div>
        <button type="button" class="d-none" id="btn-modal-school-partner-detail" data-bs-toggle="modal" data-bs-target="#school-partner-detail-modal-form">Klik</button>
        <div class="modal" id="school-partner-detail-modal-form" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="row align-items-center mb-4">
                            <div class="col">
                                <div class="h1 m-0 display-tektur">
                                    {{school_name}}
                                </div>
                                <div class="d-block mt-2">Daftar {{role == 'student' ? 'Siswa':'Guru'}}</div>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-white-naked btn-icon" data-bs-dismiss="modal" aria-label="Close" id="btn-close-modal-school-partner-detail">
                                    <i class="fa-solid fa-xmark"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header">
                                <form>
                                    <div class="input-group input-group-flush input-group-merge input-group-reverse">
                                        <input class="form-control list-search" type="search" placeholder="Cari data siswa disini..." v-model="keyword">
                                            <span class="input-group-text">
                                            <i class="fa-solid fa-search"></i>
                                        </span>
                                    </div>
                                </form>
                            </div>

                            <div v-if="filteredDataUsers.length > 0" class="table-responsive">
                                <table v-if="role == 'student'" class="table table-sm table-hover card-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width:5%">No</th>
                                            <th>Nama</th>
                                            <th class="text-center">Kelas</th>
                                            <th>Konsultan</th>
                                            <th>Pilihan 1</th>
                                            <th>Pilihan 2</th>
                                            <th>Status Penerimaan</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list fs-base">
                                        <tr v-for="(item, index) in filteredDataUsers" :key="index">
                                            <td class="text-center">{{ ++index }}</td>               
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <div class="d-block me-3">
                                                        <div class="avatar avatar-xs">
                                                            <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                                        </div>
                                                    </div>
                                                    <div class="d-block">
                                                        <div class="d-block font-bold">{{ item.fullname }}</div>
                                                        <span v-if="item.account_type == 'premium'" class="badge bg-success"><i class="fa-solid fa-star me-2"></i>Berbayar</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-center">{{ item.class ? item.class : '-' }}</td>
                                            <td>{{ item.rationalization.consultant_name ? item.rationalization.consultant_name : '-' }}</td>
                                            <td>
                                                <div class="d-block font-bold text-pink">{{ item.rationalization.university_one }}</div>
                                                <div class="d-block text-sm">{{ item.rationalization.major_one }}</div>
                                            </td>
                                            <td>
                                                <div class="d-block font-bold text-pink">{{ item.rationalization.university_two }}</div>
                                                <div class="d-block text-sm">{{ item.rationalization.major_two }}</div>
                                            </td>
                                            <td>
                                                <div class="d-block" v-if="item.rationalization.graduation_status == 0">
                                                    <span class="badge bg-warning text-dark"><i class="fa-solid fa-info-circle me-2"></i>Belum Diterima</span>
                                                </div>

                                                <div class="d-block mb-1" v-if="item.rationalization.graduation_status == 1">
                                                    <div class="d-block font-bold text-pink">
                                                        {{ item.rationalization.pass_at_university }}
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <div class="d-block small text-muted">Jurusan</div>
                                                            <div class="d-block text-sm">{{ item.rationalization.pass_at_major }}</div>
                                                        </div>
                                                        <div class="col-6">
                                                            <div class="d-block small text-muted">Tahun</div>
                                                            <div class="d-block text-sm">{{ item.rationalization.graduation_year }}</div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="d-block" v-if="item.rationalization.graduation_status == 1">
                                                    <span class="badge bg-success text-dark"><i class="fa-solid fa-check-circle me-2"></i>Diterima jalur SNBP</span>
                                                </div>                                
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table v-if="role == 'teacher'" class="table table-sm table-hover card-table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" style="width:5%">No</th>
                                            <th>Nama</th>
                                            <th style="width:15%">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list fs-base">
                                        <tr v-for="(item, index) in filteredDataUsers" :key="index">
                                            <td class="text-center">{{ ++index }}</td>               
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <div class="d-block me-3">
                                                        <div class="avatar avatar-xs">
                                                            <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                                        </div>
                                                    </div>
                                                    <div class="d-block">
                                                        <div class="d-block font-bold">{{ item.fullname }}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{{ item.access == 'counselor' ? 'Konsoler' : 'Guru Mitra' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="filteredDataUsers.length < 1" class="mt-3">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-block text-center py-4">
                                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center justify-content-between border-top pt-4">
                            <div class="d-block small"></div>
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-white-naked btn-s-1 me-3" data-bs-dismiss="modal" aria-label="Close">
                                    <div class="btn-s-1-inner">Tutup</div>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PassingGradeAlumniUtbkDetail',
    data() {
        return {
            school_name : '',
            data_users  : [],
            keyword     : "",
            role        : ""
        }
    },
    computed: {
        filteredDataUsers() {
            const keyword = this.keyword.toLowerCase();
            return this.data_users.filter(item => {
                const name = item.fullname.toLowerCase();
                return name.includes(keyword);
            });
        },
    },
    methods: {
        loadForm: function(params="", role="") {            
            this.school_name    = params.name;
            this.role           = role;

            if(role == 'student') {
                this.data_users     = params.data_student;                
            }

            if(role == 'teacher') {
                this.data_users     = params.data_teacher;                
            }

            document.getElementById('btn-modal-school-partner-detail').click();
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'users/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                const indexToDelete = this.data_users.findIndex(item => item.id === id);
                                if (indexToDelete !== -1) {
                                    this.data_users.splice(indexToDelete, 1);
                                }
                                this.$parent.$children[0].$children[0].getData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        }
        
    },
}
</script>
